import { useLayoutEffect } from 'react'
import { type BreadcrumbItem, useBreadcrumbStore } from '../_stores/breadcrumb.store'

export type { BreadcrumbItem }

export function useBreadcrumbs(items: BreadcrumbItem[]) {
  const setItems = useBreadcrumbStore((s) => s.setItems)
  const clear = useBreadcrumbStore((s) => s.clear)

  useLayoutEffect(() => {
    setItems(items)
    return () => clear()
  }, [JSON.stringify(items), setItems, clear])
}
